"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

const typographyTokensWeight = _styleUtilities.typography.weight;

const typography = ({
  theme,
  desktop,
  mobile,
  color,
  weight
}) => (0, _stylitas.css)`
  ${_styleUtilities.typography[mobile](theme)};
  color: ${_styleUtilities.palette[color](theme)};

  ${_styleUtilities.media.md`
    ${_styleUtilities.typography[desktop](theme)};
  `}

  ${weight && typographyTokensWeight[weight](theme)};
`;

const Typography = _stylitas.styled.p`
  ${typography}
`;
exports.Typography = Typography;